import Slider from '@mui/material/Slider';
import "./range.scss";

interface IRange {
    minValue: number
    defaultValue: number
}

const Range = ({minValue, defaultValue}: IRange) => {
    const marks = [
        {
            value: minValue,
            label: `${minValue}`,
        },
        {
            value: 100,
            label: '100',
        },
    ]
    return (
        <div className="Range">
            <Slider min={minValue} marks={marks} defaultValue={defaultValue} aria-label="Default"
                    valueLabelDisplay="auto"/>
        </div>
    )
}

export default Range;